import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { AuthState } from "util/useAuth/types";
import outOfLives from "./outOfLives";

interface Props {
  auth: AuthState;
  callback?: () => void;
}

export default function useOutOfLivesCallback({ auth, callback }: Props) {
  const isOutOfLives = outOfLives(auth);
  const { replace } = useRouter();

  useEffect(() => {
    if (!isOutOfLives) {
      return;
    }

    callback?.();
  }, [callback, isOutOfLives, replace]);
}
